import { useQuery } from "@tanstack/react-query";
import { getCurrentPreInvoice } from "../api/preInvoiceApi";
import { preInvoiceKeys } from "../api/preInvoiceKeys";

// Prefactura actual (usada por la pantalla visualizadora).
export const useCurrentPreInvoice = () =>
  useQuery({
    queryKey: [...preInvoiceKeys.all, "current"],
    queryFn: getCurrentPreInvoice,
  });
